import { CheckCircleOutline } from '@mui/icons-material';
import { List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material';
import React from 'react';

interface HighlightsSectionProps {
  title?: string;
  items?: string[];
}

const HighlightsSection: React.FC<HighlightsSectionProps> = ({ title = 'Key Highlights', items }) => {
  if (!items || items.length === 0) return null;

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        {title}
      </Typography>
      <List disablePadding>
        {items.map((item, idx) => (
          <ListItem key={`${item}-${idx}`} disableGutters sx={{ alignItems: 'flex-start', py: 0.5 }}>
            <ListItemIcon sx={{ minWidth: 30, mt: 0.35 }}>
              <CheckCircleOutline color="primary" fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={item} primaryTypographyProps={{ variant: 'body1', color: 'text.secondary', lineHeight: 1.7 }} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default React.memo(HighlightsSection);
